import type {AppMarketConfig} from '@smart/configs';
import * as React from 'react';
import type {AppModel} from '../../bff/app-model/create-app-model';

interface AppModelContextProps {
  appModel: AppModel;
  appMarketConfig: AppMarketConfig;
}

export const AppModelContext = React.createContext<
  AppModelContextProps | undefined
>(undefined);

export function useAppModelContext(): AppModelContextProps {
  const appModel = React.useContext(AppModelContext);

  if (!appModel) {
    throw new Error(`AppModelContext provider is missing.`);
  }

  return appModel;
}
